<template>
  <NumberField
    id="mealplan-terminal-id"
    :name="`${formNamespace}keystore.device_id`"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.terminalId')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.terminalIdPlaceholderNumber')"
    :disabled="!editMealPlan"
    :required="editMealPlan"
    :use-grouping="false"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';
import { inject } from 'vue';
const { t } = useI18n();

const fConfigStore = useFinancialConfigStore();
const { editMealPlan } = storeToRefs(fConfigStore);

const formNamespace = inject('formNamespace', '');
</script>
